<template>
  <b-table striped hover responsive :items="items" :fields="fields" :current-page="this.currentPage" :per-page="perPage" >
    <div v-for="slot in this.extraSlots" :slot="slot" slot-scope="context" @click.stop="clicked(context)">
      <slot :name="slot"></slot>
    </div>
  </b-table>
</template>
<script type="text/javascript">
export default {
  name: 'FITTable',
  components: {

  },
  props: {
    items: {
      type: [Array, Object],
      required: true
    },
    fields: [Array, Object], // This fields need to contain columns of slots
    currentPage: Number,
    perPage: Number,
    slots:Array
      },
  data() {
    return {
      extraSlots: []
    }
  },
  created(){
    if(this.slots){
      this.extraSlots = this.slots;
    }
  },
  methods:{
    clicked:function(context){
      // console.log(context.item);
      this.$emit('input',context.item);  
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Form/FITTable.vue